exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-view tr[data-v-d97e0ecc]{cursor:default}.table-view td.pointer[data-v-d97e0ecc]{cursor:pointer;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d97e0ecc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/views/ProjectsAppAccess.vue
// module id = 717
// module chunks = 1